'use client';

import { AD_PLACEMENTS } from '../adPlacements';
import { NativeAdSlot } from '../NativeAdSlot';

interface DonationOrderedGiftAdProps {
  as?: 'div' | 'li';
  className?: string;
}

export const DonationOrderedGiftAd = ({
  as,
  className,
}: DonationOrderedGiftAdProps) => (
  <NativeAdSlot
    {...AD_PLACEMENTS.donationOrderedGift}
    as={as}
    className={className}
  />
);
